export default "__VITE_ASSET__BcutlmDN__"